export const locale = {
	lang: 'it',
	data: {
		// consumi assistente AI: frasi con parametri, senza voce ngx-translate non interpola
		'Tabella con {{rows}} righe e {{columns}} colonne': 'Tabella con {{rows}} righe e {{columns}} colonne',
		'Tabella con 1 riga e {{columns}} colonne': 'Tabella con 1 riga e {{columns}} colonne',
		'Vedi tutte le {{count}} righe': 'Vedi tutte le {{count}} righe',
		'Si azzera domani, {{date}}': 'Si azzera domani, {{date}}',
		'Si azzera il {{date}}, tra {{days}} giorni': 'Si azzera il {{date}}, tra {{days}} giorni',
		'{{date}}: nessuna richiesta': '{{date}}: nessuna richiesta',
		'{{date}}: 1 richiesta, {{tokens}} token': '{{date}}: 1 richiesta, {{tokens}} token',
		'{{date}}: {{requests}} richieste, {{tokens}} token': '{{date}}: {{requests}} richieste, {{tokens}} token',
		'Oggi, {{time}}': 'Oggi, {{time}}',
		'Ieri, {{time}}': 'Ieri, {{time}}',
		'LOGIN': {
			'TITLE': 'Accedi',
			'REMEMBER_ME': 'Ricordami',
			'FORGOT_PASSWORD': 'Password dimenticata?',
			'ERROR': {
				'PASSWORD_REQUIRED': 'Inserisci la password',
				'CODE_REQUIRED': 'Credenziali non valide',
				'INVALID_CODE': 'Credenziali non valide'
			}
		},
		'FORGOT_PASSWORD': {
			'DESCRIPTION': 'Inserisci il tuo indirizzo email: ti invieremo un link per impostare una nuova password.',
			'EMAIL': 'Email',
			'SEND': 'Invia link',
			'SENT': 'Ti abbiamo inviato una mail con le istruzioni per reimpostare la password.',
			'BACK_TO_LOGIN': 'Torna al login',
			'ERROR': {
				'EMAIL_REQUIRED': 'Inserisci il tuo indirizzo email',
				'EMAIL_INVALID': 'Indirizzo email non valido',
				'GENERIC': 'Non è stato possibile inviare la mail di reimpostazione'
			}
		},
		'RESET_PASSWORD': {
			'TITLE': 'Imposta una nuova password',
			'PASSWORD': 'Password',
			'PASSWORD_CONFIRMATION': 'Conferma password',
			'SAVE': 'Salva',
			'SUCCESS': 'Password modificata',
			'BACK_TO_LOGIN': 'Torna al login',
			'ERROR': {
				'PASSWORD_REQUIRED': 'Inserisci la password',
				'PASSWORD_MISMATCH': 'Le due password non coincidono',
				'INVALID_LINK': 'Link non valido o incompleto: richiedi una nuova mail di reimpostazione.',
				'GENERIC': 'Non è stato possibile modificare la password'
			}
		},
		'NAV': {
			'HOME': {
				'TITLE': 'Dashboard'
			},
			'CALENDAR': {
				'TITLE': 'Calendario'
			},
			'REVIEWS': {
				'TITLE': 'Recensioni'
			},
			'SERVER_RT_GROUP': {
				'TITLE': 'Server RT',
				'PAYMENT_MAPPINGS': {
					'TITLE': 'Mappatura pagamenti'
				},
				'VAT_MAPPINGS': {
					'TITLE': 'Mappatura IVA'
				},
				'PAYMENT_METHOD_CATALOG': {
					'TITLE': 'Metodi di incasso'
				}
			},
			'PACKAGES': {
				'TITLE': 'Pacchetti'
			},
			'PRODUCTS': {
				'TITLE': 'Prodotti'
			},
			'RESOURCES': {
				'TITLE': 'Risorse'
			},
			'DOCUMENTS': {
				'TITLE': 'Documenti'
			},
			'ASSISTANT_USAGE': {
				'TITLE': 'Consumi AI'
			},
			'STATISTICS': {
				'TITLE': 'BI Statistiche'
			},
			'BOOKINGS': {
				'TITLE': 'Prenotazioni',

				'NEWBOOKING' : {
					'TITLE': 'Nuova Prenotazione'
				}
			},
			'MEETING_POINTS': {
				'TITLE': 'Punti di ritrovo'
			},
			'DESTINATIONS': {
				'TITLE': 'Destinazioni'
			},
			'CATEGORIES': {
				'TITLE': 'Categorie'
			},
			'INFO': {
				'TITLE': 'Informazioni Utili'
			},
			'PRICES_SERVICES': {
				'TITLE': 'Servizi & Prezzi'
			},
			'ENTITIES': {
				'TITLE': 'Anagrafiche',

				'CUSTOMERS': {
					'TITLE': 'Clienti'
				},
				'SUPPLIERS': {
					'TITLE': 'Fornitori'
				},
				'TOUR_OPERATORS': {
					'TITLE': 'Tour Operator'
				},
				'STAFF': {
					'TITLE': 'Staff'
				},
				'ALL': {
					'TITLE': 'Tutte'
				}
			},
			'MARKETPLACE': {
				'TITLE': 'Marketplace',

				'TANGERINE': {
					'TITLE': 'Tangerine'
				},
				'TOURCMS': {
					'TITLE': 'Tourcms'
				},
				'BOKUN': {
					'TITLE': 'Bokun'
				},
				'TICKETLANDIA': {
					'TITLE': 'Ticketlandia',
				},
			},
			'PLAFOND': {
				'TITLE': 'Plafond',
			},
			'DEFINITIONS': {
				'TITLE': 'Definizioni',
			},
			'DOMAINS_GROUP': {
				'TITLE': 'Gruppo Domini',

				'DOMAINS': {
					'TITLE': 'Domini'
				},
				'USER_DOMAINS': {
					'TITLE': 'Utenti Domini'
				},
				'BRANCHES': {
					'TITLE': 'Filiali'
				},
				'PAYMENTS_TYPE': {
					'TITLE': 'Metodi di pagamento'
				},
				'REQUESTS_TRANSFERS': {
					'TITLE': 'Richieste/Cessioni'
				}
			},
			'ADMIN_GROUP': {
				'TITLE': 'Super Admin',

				'USERS': {
					'TITLE': 'Utenti'
				},
				'DOMAIN_INFO': {
					'TITLE': 'Informazioni sui domini',
				},
				'DASHBOARD_TOTEM': {
					'TITLE': 'Dashboard totem',
				},
				'TURNOVER_REPORT': {
					'TITLE': 'Report Fatturato'
				},
				'PRACTICES': {
					'TITLE': 'Pratiche'
				},
				'TRANSMISSIONS': {
					'TITLE': 'Trasmissioni corrispettivi'
				},
				'UTILITIES': {
					'TITLE': 'Utilities'
				},
				'API': {
					'TITLE': 'Generazione credenziali API'
				},
				'LOGS': {
					'TITLE': 'Logs'
				}
			},
			'CRITERIA': {
				'TITLE': 'Criteri',
			},
			'SERVICES': {
				'TITLE': 'Servizi',
			},
			'PRICE_LISTS': {
				'TITLE': 'Listini Sconti'
			},
			'DISCOUNTS': {
				'TITLE': 'Sconti',
			}
		},

		// common words
		'DETAIL': 'dettaglio',
		'LIST': 'lista',
		'WELCOME_BACK': 'Ben tornato',
	}
};

